var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-landingpage-freelancer"},[_c('FreelancerLogo'),_c('FreelancerWelcome'),_c('FreelancerFeatures'),_c('BgImage',{staticClass:"people",attrs:{"image":"people"}}),_c('LPExplainVideo'),_c('FreelancerInvitation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }